import { render, staticRenderFns } from "./CourseSoldOutTip.vue?vue&type=template&id=3b460f2f&scoped=true&"
import script from "./CourseSoldOutTip.vue?vue&type=script&lang=js&"
export * from "./CourseSoldOutTip.vue?vue&type=script&lang=js&"
import style0 from "./CourseSoldOutTip.vue?vue&type=style&index=0&id=3b460f2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b460f2f",
  null
  
)

export default component.exports